/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_CreditsInputs */

const en_settings_credits_credits = /** @type {(inputs: Settings_Credits_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const zh_settings_credits_credits = /** @type {(inputs: Settings_Credits_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`额度`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Settings_Credits_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_credits_credits = /** @type {((inputs?: Settings_Credits_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_credits(inputs)
	return zh_settings_credits_credits(inputs)
});
export { settings_credits_credits as "settings.credits.credits" }